import { request } from 'bdvp-common/src/utils';

export const typeDefs = `
    type UserLocation {
        metroCode: Int
        postalCode: String
        country: String
    }
`;

const Query = {
    userLocation: (_root, { token }) => {

        return request('https://data-graph.mlb.com/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { 'Authorization': `Bearer ${token}` }),
            },
            body: JSON.stringify({
                query: `
                    query UserQuery {
                        user {
                            geoDetection {
                                metroCode
                                postalCode
                                country
                            }
                        }
                    }
                `,
            }),
        }).then(res => ({
            __typename: 'UserLocation',
            ...res.data?.user?.geoDetection,
        }));

    },
};

export const resolvers = {
    Query,
};
